import {
  FETCH_APIKEY_REQUEST,
  FETCH_APIKEY_SUCCESS,
  FETCH_APIKEY_FAILURE,
  CREATE_APIKEY_REQUEST,
  CREATE_APIKEY_SUCCESS,
  CREATE_APIKEY_FAILURE,
  DELETE_APIKEY_REQUEST,
  DELETE_APIKEY_SUCCESS,
  DELETE_APIKEY_FAILURE,
} from '../actions/apikeyAction';

const initialState = {
  apiKey: null,
  loading: false,
  error: null,
};
const ApikeyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APIKEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_APIKEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKey: action.payload,
        error: null,
      };
    case FETCH_APIKEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_APIKEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_APIKEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKey: action.payload,
        error: null,
      };
    case CREATE_APIKEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_APIKEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_APIKEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKey: state.apiKey.map((apikey) =>
          apikey.id === action.payload.id ? action.payload : apikey
        ),
        error: null,
      };
    case DELETE_APIKEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ApikeyReducer;
